/* Einstiegspunkt der App.
 *
 * Reihenfolge der Importe ist bedeutsam: supabase/client.js sichert beim Laden
 * den Adressanker eines Einladungs- oder Zurücksetzen-Links, bevor Supabase ihn
 * entfernt. Dieser Import muss deshalb ganz oben stehen.
 */

import './supabase/client.js';

import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify.js';
import i18n from './i18n/index.js';
/* NACH dem Vuetify-Plugin importieren: dessen Basis-Stylesheet würde sonst
   das Grassrunners-Design überschreiben. */
import './styles/main.css';
/* Profilansicht (Auftrag B3): nach main.css, überschreibt dessen .panel-/.info-Regeln */
import './styles/profile.css';

createApp(App).use(vuetify).use(i18n).mount('#app');

/* Service Worker — Offline-Cache und Web Push.
   Die Precache-Liste erzeugt vite-plugin-pwa beim Bauen, siehe src/sw.js. */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((e) => console.log('SW fail', e));
  });
}
